import { render } from "./FailedToSend.vue?vue&type=template&id=0ab11eea"
import script from "./FailedToSend.vue?vue&type=script&lang=js"
export * from "./FailedToSend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__